import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type Platform = 'android' | 'ios' | null;

const AppDownloadBanner: React.FC = () => {
    const [isVisible, setIsVisible] = useState<boolean>(false);
    const [platform, setPlatform] = useState<Platform>(null);
    const { t } = useTranslation();

    useEffect(() => {
        const isDismissed = sessionStorage.getItem('appBannerDismissed');
        if (isDismissed) return;

        const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

        if (/android/i.test(userAgent)) {
            setPlatform('android');
            setIsVisible(true);
        } else if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
            setPlatform('ios');
            setIsVisible(true);
        }
    }, []);

    const handleClose = () => {
        sessionStorage.setItem('appBannerDismissed', 'true');
        setIsVisible(false);
    };

    if (!isVisible || !platform) return null;

    const storeLink =
        platform === 'android'
            ? 'https://play.google.com/store/apps/details?id=app.sunpoint.sktech'
            : 'https://apps.apple.com/us/app/sktech/id6738701533';

    const message =
        platform === 'android'
            ? t("TryourAndroidapp")
            : t("TryourIphoneapp");

    return (
        <div
            id="app-banner"
            style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                width: '100%',
                backgroundColor: 'rgb(56 75 255 / 90%)',
                color: 'white',
                textAlign: 'center',
                padding: '10px',
                zIndex: 9999,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                fontFamily: 'sans-serif',
                height: '100px',
            }}
        >
            <a
                href={storeLink}
                target="_blank"
                rel="noopener noreferrer"
            >
                <img
                    style={{ width: '55px', height: '55px', borderRadius: '10px' }}
                    src="/assets/mobileLogo.jpg"
                    alt="logo"
                />
            </a>
            <span style={{ flexGrow: 1, marginLeft: 10 }}>{message}</span>
            <a
                id="app-banner-link"
                href={storeLink}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    color: 'white',
                    textDecoration: 'underline',
                    marginLeft: '10px',
                }}
            >
                {t('Open')}
            </a>
            <button
                id="app-banner-close"
                onClick={handleClose}
                style={{
                    background: 'none',
                    border: 'none',
                    color: 'white',
                    fontSize: '20px',
                    cursor: 'pointer',
                    marginLeft: 'auto',
                    marginTop: '-50px',
                }}
            >
                ×
            </button>
        </div>
    );
};

export default AppDownloadBanner;
